import { maskTpl } from './mask';
import { infoCardTpl } from './infoCard';
import { etcListTpl } from './etclist'

export { maskTpl, infoCardTpl, etcListTpl }